(() => {
  // Section scripts may be included again by the theme editor. Bind once globally.
  if (window.odpartsVehicleSearch) {
    window.odpartsVehicleSearch.mount(document);
    return;
  }
  const instances = new WeakMap();
  function initialize(root) {
    if (instances.has(root)) return;
    const tabs = Array.from(root.querySelectorAll('[data-od-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-od-panel]'));
    const tablist = root.querySelector('[role="tablist"]');
    if (!tabs.length || !tablist) return;
    const controller = new AbortController();
    const activate = (name, focus = false) => {
      const activeTab = tabs.find(tab => tab.dataset.odTab === name);
      if (!activeTab) return;
      const departing = panels.find(panel => panel.dataset.active === 'true');
      if (focus || departing?.contains(document.activeElement)) activeTab.focus();
      tabs.forEach(tab => {
        const active = tab === activeTab;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      panels.forEach(panel => {
        const active = panel.dataset.odPanel === name;
        panel.dataset.active = String(active);
        panel.inert = !active;
        if (active) panel.removeAttribute('aria-hidden');
        else panel.setAttribute('aria-hidden', 'true');
      });
    };
    tablist.addEventListener('click', event => {
      const tab = event.target.closest('[data-od-tab]');
      if (tab && tablist.contains(tab)) activate(tab.dataset.odTab);
    }, {signal: controller.signal});
    tablist.addEventListener('keydown', event => {
      const index = tabs.indexOf(event.target);
      if (index < 0) return;
      let next;
      if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
      else if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = tabs.length - 1;
      else if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        activate(tabs[index].dataset.odTab);
        return;
      } else return;
      event.preventDefault();
      tabs.forEach((tab, i) => { tab.tabIndex = i === next ? 0 : -1; });
      tabs[next].focus();
    }, {signal: controller.signal});
    tablist.addEventListener('focusout', event => {
      if (!tablist.contains(event.relatedTarget)) tabs.forEach(tab => {
        tab.tabIndex = tab.getAttribute('aria-selected') === 'true' ? 0 : -1;
      });
    }, {signal: controller.signal});
    const tireMount = root.querySelector('.gf-YMM-forms');
    const status = root.querySelector('[data-od-tire-status]');
    const updateStatus = () => {
      if (status) status.hidden = !!tireMount?.querySelector('select');
      if (document.documentElement.lang.split('-')[0].toLowerCase() === 'fr') {
        const labels = {
          'Tire Season_Winter': 'Hiver',
          'Tire Season_All Weather': 'Toutes Saisons (3PMSF)',
          'Tire Season_All Terrain/Mud Terrain': 'Tout-Terrain (AT/MT)'
        };
        for (const option of tireMount?.querySelectorAll('option') || []) {
          const label = labels[option.value];
          if (label && option.textContent !== label) option.textContent = label;
        }
      }
    };
    const observer = new MutationObserver(updateStatus);
    if (tireMount) observer.observe(tireMount, {childList: true, subtree: true});
    updateStatus();
    const timeout = window.setTimeout(() => {
      if (status && !status.hidden) status.textContent = status.dataset.unavailable;
    }, 15000);
    activate('parts');
    tablist.hidden = false;
    instances.set(root, {
      activate,
      dispose() { controller.abort(); observer.disconnect(); clearTimeout(timeout); instances.delete(root); }
    });
  }
  function mount(scope) {
    if (scope.matches?.('[data-odparts-search]')) initialize(scope);
    scope.querySelectorAll?.('[data-odparts-search]').forEach(initialize);
  }
  window.odpartsVehicleSearch = {mount};
  mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-odparts-search]').forEach(root => instances.get(root)?.dispose());
  });
  document.addEventListener('shopify:block:select', event => {
    const root = event.target.closest('[data-odparts-search]');
    const panel = event.target.closest('[data-od-panel]');
    if (root && panel) instances.get(root)?.activate(panel.dataset.odPanel);
  });
})();
